import { render, staticRenderFns } from "./BubbleExample.vue?vue&type=template&id=f48d0926&"
import script from "./BubbleExample.vue?vue&type=script&lang=js&"
export * from "./BubbleExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports